import { Component, OnDestroy, OnInit } from "@angular/core";
import { VendingProgressComponent } from "../../_general/vending-progress/vending-progress.component";
import { AppService } from "../../../services/app.service";

@Component({
	selector: "tur-vending-progress",
	templateUrl:
		"../../_general/vending-progress/vending-progress.component.html",
	styleUrls: [
		"../../_general/vending-progress/vending-progress.component.scss",
	],
})
export class TurVendingProgressComponent
	extends VendingProgressComponent
	implements OnInit, OnDestroy {
	steps: { title: string; current: boolean }[] = [
		{
			title: this.translate("🌐General.Vending.Ready"),
			current: true,
		},
		{
			title: this.translate("🌐General.Vending.Paying"),
			current: false,
		},
	];

	constructor(app: AppService) {
		super(app);
	}
}
